import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query'
import ModalController from 'webmodals/modal.controller'
import modals from 'webmodals/modals'
import eventListener from 'servicestack/event-listener'

const cells = [1,2,3,4,5,6,7,8,9,null,0];
const carriers = [
    {label:'Verizon Wireless',gateway:'vtext.com'},
    {label:'AT&T Mobility',gateway:'txt.att.net'},
    {label:'T-Mobile',gateway:'tmomail.net'},
    {label:'Sprint Corporation',gateway:'messaging.sprintpcs.com'},
    {label:'U.S. Cellular',gateway:'email.uscc.net'},
    {label:'Alltel',gateway:'text.wireless.alltel.com'},
    {label:'Boost Mobile',gateway:'myboostmobile.com'},
    {label:'Project Fi',gateway:'msg.fi.google.com'},
    {label:'C Spire Wireless',gateway:'cspire1.com'}
];


class RemoteUploadMediaPromptController extends ModalController {
    constructor($uibModalInstance, $scope, options) {
        super($uibModalInstance)
        const $ctrl = this;
        $ctrl.bus = new ServiceBus()
        $ctrl.title = options.title || `Upload Image...`;
        $ctrl.subTitle = options.subTitle;
        $ctrl.cells = cells;
        $ctrl.carriers = carriers;
        //$ctrl.carrier = carriers[0].gateway;

        $ctrl.request = Object.assign({
            phoneNumber: ''
        }, options.request);


        document.addEventListener("keydown", keyDownTextField, false);
        $ctrl.$onDestroy = () =>  document.removeEventListener("keydown", keyDownTextField, true);

        function keyDownTextField(e) {
            if(e.keyCode == 8)
                $scope.$apply(() => $ctrl.removeLast());
            if(e.keyCode == 27)
                $scope.$apply(() => $ctrl.clear());
            if(e.keyCode >= 48 && e.keyCode <= 57)
                $scope.$apply(() => $ctrl.addDigit(e.keyCode - 48));
            if([10,13].indexOf(e.keyCode) >= 0)
                $scope.$apply(() => $ctrl.submit());
        }
    }
    
    removeLast() {
        let $ctrl = this;
        if($ctrl.phoneNumber && $ctrl.phoneNumber.length)
            $ctrl.phoneNumber = $ctrl.phoneNumber.substr(0, $ctrl.phoneNumber.length-1);
    }
    
    addDigit(digit) {
        let $ctrl = this;
        if(!$ctrl.phoneNumber || $ctrl.phoneNumber.length < 10)
            $ctrl.phoneNumber = ($ctrl.phoneNumber || '') + digit;
    }

    clear() {
        let $ctrl = this;
        $ctrl.phoneNumber = '';
        $ctrl.carrier = '';
    }

    submit() {
        const $ctrl = this;
        if(!$ctrl.carrier)
            return $ctrl.message = 'Please select a carrier';
 
        if(!$ctrl.phoneNumber || $ctrl.phoneNumber.length !== 10)
            return $ctrl.message = 'Please provide a valid 10-digit mobile number';
        let req = {
            subscriptionId: $ctrl.bus.subscriptionId(),
            //phoneNumbers: [$ctrl.phoneNumber],
            emailAddresses: [$ctrl.phoneNumber + '@' + $ctrl.carrier]
        };

        $ctrl.bus.send(`SendUploadMediaLink.json`, req).then(
            res => $ctrl.close(res.data),
            res => $ctrl.message = 'Could send message!');
    }
}

export default RemoteUploadMediaPromptController;